import { VehicleSidePanel } from 'components/VehicleSidePanel';
import { useCurrentUser } from 'hooks/selectors';
import { useGetSidePanelBidsQuery } from 'services/api/my-bids';
import styled from 'styled-components';

const SidePanelWrapper = styled.div`
  position: absolute;
  max-width: 230px;
  min-width: 230px;
  right: 0;
  top: 54px;
  bottom: 0;
  height: calc(100% - 30px);
  overflow-y: scroll;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const SidePanel = () => {
  const user = useCurrentUser();
  const { data: myBids } = useGetSidePanelBidsQuery(undefined, { skip: !user || user.role !== 'buyer' });
  return (
    <SidePanelWrapper hidden={!myBids || myBids.count === 0}>
      <VehicleSidePanel />
    </SidePanelWrapper>
  );
};
